import {
  useGetAllNotificationsViewedMutation,
  useGetNumberOfNotViewedListQuery,
  useLazyGetNotificationListQuery
} from 'modules/notification/api'

import { useTypedSelector } from './useTypedSelector'

export const useNotifications = () => {
  const [getNotification, { data: notification, isLoading: isNotificationLoading }] = useLazyGetNotificationListQuery()
  const { token } = useTypedSelector((state) => state.authReducer)

  const { data: notificationNotViewed, refetch: refetchNotification } = useGetNumberOfNotViewedListQuery('', {
    pollingInterval: 86400000,
    skip: !token
  })
  const [getAllNotificationsViewed] = useGetAllNotificationsViewedMutation()

  return {
    isNotificationLoading,
    getNotification,
    notification,
    notificationNotViewed,
    refetchNotification,
    getAllNotificationsViewed
  }
}
